<template>
	<footer class="footer-buttons">
		<button
			class="b360-btn"
			data-test="action-button"
			:class="{
				success: success,
				disabled: primaryButtonDisabled,
				'b360-modal-action-btn': isSaveModal,
				'b360-modal-delete-btn': isDeleteModal,
			}"
			:disabled="primaryButtonDisabled"
			@click="$emit('handleClick')"
		>
			<span v-if="!waiting && !success">{{ getButtonText }}</span>
			<font-awesome-icon
				class="waiting-animation"
				:icon="['far', 'circle-notch']"
				v-if="waiting"
			/>
			<font-awesome-icon
				class="success-animation"
				:icon="['far', 'check']"
				v-if="success"
			/>
		</button>
		<button
			class="b360-btn b360-modal-cancel-btn"
			data-test="cancel-button"
			@click="$emit('close')"
		>
			Cancel
		</button>
	</footer>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
	name: 'OverviewModalFooter',
	props: {
		success: Boolean,
		waiting: Boolean,
		isDeleteModal: Boolean,
		isSaveModal: Boolean,
		primaryButtonName: String,
		primaryButtonDisabled: {
			default: false,
			type: Boolean,
		},
	},
		components: {
		FontAwesomeIcon,
	},
	computed: {
		getButtonText() {
			return this.primaryButtonName ? this.primaryButtonName : 'Save';
		},
	},
};
</script>

<style lang="scss" scoped>
.footer-buttons {
	border-top: 1px solid $border-color-light;
	@include rem('padding', 15px 20px);
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 20px;

	.b360-modal-action-btn,
	.b360-modal-delete-btn {
		margin-left: 0;

		&:disabled {
			cursor: not-allowed;
			background-color: $b360-color--gray__light;
			color: $b360-color--gray__darkest;
		}

		&.success {
			background: $success;
		}

		.waiting-animation {
			animation: spin 1.5s ease-in-out infinite;
			@include rem(font-size, 20px);
		}

		&.success {
			background-color: $success;
			@include rem(font-size, 20px);

			&:hover {
				background-color: darken($success, 5%);
			}

			.success-animation {
				animation: scaleIn 0.6s cubic-bezier(0.28, 0.84, 0.42, 1);
			}
		}
	}
}
</style>
